var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 100",
    style: {
      enableBackground: "new 0 0 250 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#272D61;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "64.83,96 0.54,96 0.54,31.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0.54,5.04 64.83,5.04 64.83,69.33  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.97,
    y: 5.04,
    className: "st0",
    width: 70.64,
    height: 16.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.97,
    y: 79.55,
    className: "st0",
    width: 70.64,
    height: 16.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.97,
    y: 41.81,
    className: "st0",
    width: 70.64,
    height: 16.45
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.49,47.84c0,28.64-18.43,43.83-40.9,43.83c-23.26,0-39.6-17.04-39.6-42.22c0-26.42,17.38-43.7,40.9-43.7 C233.94,5.74,249.49,23.15,249.49,47.84z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue);
export default __webpack_public_path__ + "static/media/logoBlue.30d048c54da5d96554560632e33a8291.svg";
export { ForwardRef as ReactComponent };